import { render, staticRenderFns } from "./SignaturePlacement.vue?vue&type=template&id=0a21de43"
import script from "./SignaturePlacement.vue?vue&type=script&lang=ts"
export * from "./SignaturePlacement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports